<template>
    <div>
        <div v-if="$slots.button || !hideButton">
            <slot name="button">
                <b-link @click="showHistoryModal = true" v-b-tooltip.hover title="F8 Hotkey">
                    History <i class="fas fa-history" />
                </b-link>
            </slot>
        </div>

        <b-modal id="id" size="xl" v-model="showHistoryModal" cancel-title="" cancel-variant="link" cancel-disabled
            @shown="modalShown" title="History" ok-title="Close" no-fade>
            <history-component ref="history-component" v-model="obj" :search-type="searchType" />
        </b-modal>
    </div>
</template>

<script lang="ts">
import { Component, Mixins, VModel, Prop, PropSync, Watch, Ref } from 'vue-property-decorator';
import HistoryComponent from "@/components/HistoryComponent.vue";
import HistoryHotkeyMixin from "@/mixins/HistoryHotkeyMixin";
import { CaseDetail } from '@/models/Case';
import { Patient } from "@/models/Patient";
import { Prescriber } from "@/models/Prescriber";
import { UserTask } from "@/models/UserTask";
import { Prescription } from "@/models/Prescription";
import { Store } from "@/models/Store";
import { Order } from "@/models/Order";
import { Team } from "@/models/Team";
import { Vendor } from "@/models/Vendor";
import { DrugCategory } from "@/models/DrugCategory";
import { User } from "@/models/User";
import { AutoRefillSubscription } from "@/models/AutoRefillSubscription";
import { CustomTextMessageTemplate } from '@/models/CustomTextMessageTemplate';
import { AcceptanceRecord } from '@/models/AcceptanceRecord';

@Component({
    components: { HistoryComponent },
})
export default class HistoryModal extends Mixins(HistoryHotkeyMixin) {
    @VModel({ required: true }) obj!: any;
    @PropSync('show', { required: false, type: Boolean, default: false }) showModal!: boolean;
    @Prop({ type: Boolean, default: false }) hideButton!: boolean;
    @Ref('history-component') historyComponent!: HistoryComponent;

    protected searchType: string = "Patient";

    modalShown() {
        if (!this.obj) console.warn("missing obj!");

        // Ensure searchType is set correctly before getting history
        this.onObjChanged(this.obj, null);
        this.historyComponent.getHistoryForObject(this.obj);
    }

    @Watch('obj', { immediate: true })
    onObjChanged(value: any, _oldValue: any) {
        if (value instanceof CaseDetail) {
            this.searchType = "Case";
        } else if (value instanceof Patient) {
            this.searchType = "Patient";
        } else if (value instanceof Prescriber) {
            this.searchType = "Prescriber";
        } else if (value instanceof UserTask) {
            this.searchType = "Task";
        } else if (value instanceof Prescription) {
            this.searchType = "Prescription";
        } else if (value instanceof Store) {
            this.searchType = "Store";
        } else if (value instanceof Order) {
            this.searchType = "Order";
        } else if (value instanceof Team) {
            this.searchType = "Team";
        } else if (value instanceof Vendor) {
            this.searchType = "Vendor";
        } else if (value instanceof DrugCategory) {
            this.searchType = "DrugCategory";
        } else if (value instanceof User) {
            this.searchType = "User";
        } else if (value instanceof AutoRefillSubscription) {
            this.searchType = "AutoRefill";
        } else if (value instanceof CustomTextMessageTemplate) {
            this.searchType = "Custom Text Template";
        } else if (value instanceof AcceptanceRecord) {
            this.searchType = "Acceptance Record";
        } else {
            console.warn("unable to identify searchType of value", value);
        }
        //console.log("obj changed", value, "searchType", this.searchType);
    }
}
</script>

<style scoped></style>
